@if (inputCtrlType !== 'submit' && inputCtrlType !== 'button') {
  <ng-container [formGroup]="form">
    @if (inputCtrlType === 'hidden') {
      <input type="hidden" [formControlName]="attributes.name">
    }
    @if (inputCtrlType === 'checkbox') {
      <div class="field" [class.error]="hasError">
        <div class="ui checkbox">
          <input
            [id]="nodeId"
            type="checkbox"
            [formControlName]="attributes.name"
            [checked]="attributes.value"
            [disabled]="disabled"
            [attr.aria-describedby]="messageIds"
            [attr.aria-invalid]="hasError ? 'true' : null">
          <label [for]="nodeId">{{getNodeLabel(node)}}</label>
        </div>
      </div>
    }
    @if (inputCtrlType === 'default') {
      <div class="field" [class.error]="hasError">
        <label [for]="nodeId">{{getNodeLabel(node)}}</label>
        <input
          [id]="nodeId"
          [type]="attributes.type"
          [formControlName]="attributes.name"
          [placeholder]="getNodeLabel(node)"
          [disabled]="disabled"
          [attr.aria-describedby]="messageIds"
          [attr.aria-invalid]="hasError ? 'true' : null">
      </div>
    }
  </ng-container>
}
@if (inputCtrlType === 'submit' || inputCtrlType === 'button') {
  <button
    [id]="nodeId"
    [type]="attributes.type"
    class="ui primary button"
    [ngClass]="{'loading': isFormSubmitting}"
    [name]="attributes.name"
    [value]="attributes.value"
    [disabled]="disabled"
    [attr.aria-describedby]="messageIds">{{getNodeLabel(node)}}</button>
}
@for (message of node.messages; track message; let messageIndex = $index) {
  <div
    class="ui message"
    [class.error]="message.type === 'error'"
    [class.info]="message.type === 'info'"
    [class.success]="message.type === 'success'"
    [id]="nodeId + '-message-' + messageIndex"
    [attr.role]="message.type === 'error' ? 'alert' : 'status'"
    [attr.dataTestid]="'node/input/' + attributes.name + '/message/' + message.id">
    {{message.text}}
  </div>
}
